import React, { useEffect } from "react";
import { Box, Typography, Container,Grid } from "@mui/material";
import { motion} from "framer-motion";
import Footer from "./Footer";

const Manufacturingcs1 = () => {
    useEffect(() => {
            window.scrollTo(0, 0); // Scroll to top when component loads
          },[]);

  return (
    <Box  sx={{backgroundColor:"#C4D8E2"}}>

      {/* Hero Section */}
      <Box
        sx={{
          height: "100vh",
          backgroundImage: `url('/image/manufaccs1.jpg')`, // replace with your image
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          px: { xs: 3, md: 10 },
        }}
      >
        <Box maxWidth="1200px"  p={4} borderRadius={2}>
          <Typography variant="h1" sx={{ color: "white",  fontWeight:"bold" , fontSize: { xs: "28px", md: "70px" }}}>
         
          Mechanical systems manufacturer reduces product damage
          </Typography>
          <Typography variant="body1" sx={{ color: "white", fontSize: "18px" }}>
          A supply chain assessment and packaging redesign drives savings     </Typography>
        </Box>
      </Box>

      {/* Business Needs Section */}
      <Container sx={{ py: 10 }}>
      <Typography variant="body1" sx={{ color: "#333", fontSize: "18px" }}mb={8}>
      A major residential and commercial mechanical systems manufacturer experienced a high volume of damage claims, resulting in retail markdowns and returns that impacted the bottom line. The company partnered with Tech Informatic Solutions's supply chain experts to find a solution that would transform packaging and alleviate mounting costs.     </Typography>
     
        
        <Typography variant="h4" fontWeight="bold" mb={3}>
          Business Needs
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        The manufacturer approached Tech Informatic Solutions and its expert packaging engineers for a look at its supply chain, a packaging redesign and product handling strategies to reduce damage claims and reverse logistics costs. Together, the teams collaborated on a total supply chain assessment and packaging design to address the problem and set a new path to success. </Typography>
        



         {/* outcome Section */}
       <Typography variant="h4" fontWeight="bold" mb={-12}>
         Outcomes
        </Typography>
       
      </Container>
      <Container maxWidth="lg">
        <Grid container spacing={3} sx={{ mt: 4 }} mb={14}>
          {[
            {
              bgImage: "/image/f3.jpeg", // Replace with actual image path
              points: [
                "Sustains product quality throughout the supply chain",
                "Reduces damage and lowers warranty claims",
                "Alleviates strain between manufacturer and distributor"
              ],
            },
           
          ].map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <motion.div
                whileHover={{ y: -5 }} // Jump effect on hover
                transition={{ type: "spring", stiffness: 200, damping: 10 }}
              >
                 <Box
                  sx={{
                    position: "relative",
                    backgroundImage: `url(${feature.bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "12px",
                    p: 4,
                    minHeight: "250px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between", // ✅ Ensures equal spacing
                    overflow: "hidden",
                    textAlign: "left", // ✅ Left-aligned text
                  }}
                >
                  {/* Dark Overlay for Better Visibility */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.6)", // Reduced brightness
                      zIndex: 1,
                    }}
                  />

                  {/* Bullet Points - Always Visible */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px", // ✅ Creates space between two bullet points
                      minHeight: "100%", // ✅ Ensures equal height
                      mt:6,
                    }}
                  >
                    {feature.points.map((point, i) => (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start", // ✅ Aligns bullet with text properly
                          gap: "8px",
                          color: "white",
                          minHeight: "50px", // ✅ Ensures each bullet aligns properly
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontSize: "1.5rem",
                            lineHeight: "1.5rem", // ✅ Ensures bullet stays aligned
                          }}
                        >
                          ✅
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: "1rem", md: "1.2rem" },
                            lineHeight: "1.5rem", // ✅ Ensures text stays in line
                          }}
                        >
                          {point}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>


{/* banner Section */}
<Box
        sx={{
          height: "50vh",
          backgroundImage: `url('/image/manufacimg2.jpg')`, // replace with your image
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          px: { xs: 3, md: 10 },
        }}
      >
        <Box maxWidth="1200px"  p={4} borderRadius={2}>
          <Typography variant="h1" sx={{ color: "white",  fontWeight:"bold" , fontSize: { xs: "22px", md: "42px" }}}>
         
          The total supply chain (TSC) assessment was the catalyst for improvements in a highly competitive market.  </Typography>
        </Box>
      </Box>




      <Container sx={{ py: 10 }}>
      
       
      <Typography  variant="h4" fontWeight="bold" mb={3}>
      Solution
          </Typography>
        <Typography variant="h5" fontWeight="bold" mb={3}>
        Documenting and assessing
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3  }}>
        Tech Informatic Solutions conducted a supply chain assessment to document every node and the handling hazards each one presented. The assessment began with visits to all manufacturing sites. It followed the product from numerous distribution centers (DCs) to the point of sale. At each location, the team observed warehouse handling techniques, including freight loading and unloading. It documented post-transit appearance and stocking processes at the DCs and store locations. The assessment determined that most of the damage occurred in transit to distribution centers and within the store locations. </Typography>
        
        <Typography variant="h5" fontWeight="bold" mb={3}>
        Replicating damage through testing
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        After the observation and reporting stages, the teams developed testing protocols to replicate the observed damage. In the test lab, the team implemented an environmental re-creation to pinpoint areas where the redesign would be most beneficial. Tech Informatic Solutions also conducted a series of drop tests, vibration tests and clamp tests to address both the cosmetic issues and functional damage. </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        When the tests were complete, the teams examined the results and developed new packaging concepts to sustain product quality along the new supply chain. The solution helped reduce warranty claims and alleviated much of the strain between the manufacturer and its distributor.</Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        The manufacturer will continue to reduce costs and damage issues by extending its Tech Informatic Solutions partnership across additional product offerings. </Typography>
        
       
</Container>



<Footer/>
    </Box>


  );
};

export default Manufacturingcs1;
